// @ts-nocheck
import React, { useEffect, useState, useMemo, useRef } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import EditSlot from "./EditSlot";
import { post } from "../../../../Services/ApiHandler";
import { URLS } from "../../../../Services/Constant";

const customStyles = {
  control: (p, s) => ({
    ...p,
    backgroundColor: "#F4F4F4",
    borderColor: s.isFocused ? "#333" : "#ccc",
    boxShadow: s.isFocused ? "0 0 0 1px #333" : "none",
    "&:hover": { borderColor: "#333" },
  }),
};

const fmt = (t) => moment(t, "HH:mm:ss").format("hA");

const PrefilledSlots = ({
  timeSlots = [],
  availableSlots = [],
  property_id,
  room_id,
  selectedDay,
  viewPrices,
}) => {
  const [list, setList] = useState([]);
  const saving = useRef(false);
  const options = useMemo(() => {
    const fromPrefill = timeSlots.map((s) => ({
      id: s.time_slot_id,
      value: s.time_slot_id,
      label: s.timeslot_name,
      timeslot_type: s.timeslot_type,
    }));
    const map = new Map();
    [...fromPrefill, ...availableSlots].forEach((o) => map.set(o.id, o));
    return [...map.values()];
  }, [timeSlots, availableSlots]);

  useEffect(() => {
    setList((prev) =>
      timeSlots.map((s, i) => {
        const rowId = s.time_slot_id ?? i;
        const existing = prev.find((d) => d.rowId === rowId);
        if (existing) return existing; // keep typed values
        return {
          rowId,
          sno: i + 1,
          name: `${s.timeslot_name}, ${fmt(s.start_time)} - ${fmt(s.end_time)}`,
          slotType: { value: s.time_slot_id, label: s.timeslot_name },
          slotTime: { value: s.time_slot_id, label: s.timeslot_type },
          propPrice: s.base_price,
          vowCommission: "",
          extraPrice: "",
          extraCommission: "",
          same_price: [],
        };
      }),
    );
  }, [timeSlots]);

  // EditSlot calls setData(prev => ...) or setData(obj); support both per item
  const updateItem = (index) => (updater) =>
    setList((prev) =>
      prev.map((d, i) =>
        i !== index
          ? d
          : typeof updater === "function"
            ? updater(d)
            : { ...d, ...updater },
      ),
    );

  const handleSlotSubmit = async (item) => {
    if (saving.current) return;

    if (!room_id) {
      toast.error("Submit the room first, then save slot prices");
      return;
    }
    if (!item?.slotType) return toast.error("Slot Type is required");
    if (!item?.slotTime?.value) return toast.error("Slot Time is required");
    if (!item?.propPrice) return toast.error("Property Price is required");
    if (!item?.vowCommission) return toast.error("Vow Commission is required");

    const payload = {
      property: property_id,
      property_room: room_id,
      time_slot: item.slotTime.value,
      property_price: item.propPrice,
      vow_commision: item.vowCommission,
      extra_person_price: item.extraPrice || 0,
      extra_person_commision: item.extraCommission || 0,
      price_for: selectedDay,
    };
    if (item.same_price?.length) {
      payload.same_price_for = item.same_price;
    }

    saving.current = true;
    try {
      const res = await post(
        `${URLS.PROPERTY_ROOM_CREATE_MASTER}create/`,
        payload,
      );
      if (res?.status === "success") {
        toast.success(res?.message);
        setList((prev) => prev.filter((d) => d.rowId !== item.rowId));
        await viewPrices?.();
      }
    } finally {
      saving.current = false;
    }
  };

  return (
    <div>
      {list.map((item, index) => (
        <EditSlot
          key={item?.rowId}
          slotId="add"
          viewOnly={false}
          currentSlot={selectedDay}
          customStyles={customStyles}
          availableSlots={options}
          data={item}
          setData={updateItem(index)}
          handleSlotSubmit={() => handleSlotSubmit(item)}
        />
      ))}
    </div>
  );
};

export default PrefilledSlots;
